module.exports = __webpack_public_path__ + "static/media/boutique_dreyfus_icon.9644774c.svg";